import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurDrawer from '../../../common/aur-drawer/AurDrawer';
import AurDrawerHeader from '../../../common/aur-drawer/AurDrawerHeader';

const Drawer: React.FC = () => {
  const [drawerToggleState, setDrawerToggleState] = useState(false);

  const drawerContent = <div>Drawer Content</div>;

  const buttons = [
    <div>Button 1</div>,
    <div>Button 2</div>,
    <div>Button 3</div>,
  ];
  const title = 'Drawer Header';
  const titleCssClass = 'drawer-header-title';
  const drawerHeader2 = (
    <AurDrawerHeader
      buttons={buttons}
      title={title}
      titleCssClass={titleCssClass}
    />
  );

  const showDrawer = () => {
    setDrawerToggleState(true);
  };

  const closeDrawer = () => {
    setDrawerToggleState(false);
  };
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Drawer</h1>
        <div>
          Temporary navigation drawers can toggle open or closed. Closed by
          default, the drawer opens temporarily above all other content until a
          section is selected. The Drawer can be cancelled by clicking the
          overlay or pressing the Esc key. It closes on user action (i.e. close
          button.)
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <div onClick={showDrawer}>Open Drawer</div>
          <AurDrawer
            open={drawerToggleState}
            anchor="right"
            drawerHeader={drawerHeader2}
            drawerContent={drawerContent}
            onClose={() => closeDrawer()}
          />
        </div>
      </div>
    </>
  );
};

export default Drawer;
